import { catchError } from 'rxjs/operators';
import { Injectable, Injector, NgZone } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorInterceptorService implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private ngZone: NgZone,
    private readonly modalService: BsModalService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const router = this.injector.get(Router);
        if (error.status === 401) {
          localStorage.removeItem('currentUser');
          this.ngZone.run(() => {
            this.modalService.hide(1);
            return router.navigate(['login']);
          });
        }

        return throwError(error);
      }),
    );
  }
}
